module.exports = __webpack_public_path__ + "static/media/26.57c1097c.JPG";